import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as l}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as e}from"../../icon-registry.js";const o=e("g2a_pay",l`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            static
            fill="none">
            <g clip-path="url(#clip0_10037_571)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9997 16.9196L7.08008 12L11.9997 24.0001L23.9999 12L11.9997 16.9196Z"
                    fill="#E1451B" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9999 7.08008L0 11.9997L11.9999 23.9999L7.08022 11.9997L11.9999 7.08008Z"
                    fill="#EC8A0D" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9999 0L0 11.9999L11.9999 7.08022L16.9195 11.9999L11.9999 0Z"
                    fill="#316BA6" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M24.0001 11.9999L12 0L16.9196 11.9999L12 16.9195L24.0001 11.9999Z"
                    fill="#4A9DD2" />
            </g>
            <defs>
                <clipPath id="clip0_10037_571">
                    <rect
                        width="24"
                        height="24"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{o as G2APay};
